import { render, staticRenderFns } from "./PasswordResetErrorCard.vue?vue&type=template&id=12c06307&scoped=true"
import script from "./PasswordResetErrorCard.vue?vue&type=script&lang=js"
export * from "./PasswordResetErrorCard.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetErrorCard.vue?vue&type=style&index=0&id=12c06307&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c06307",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12c06307')) {
      api.createRecord('12c06307', component.options)
    } else {
      api.reload('12c06307', component.options)
    }
    module.hot.accept("./PasswordResetErrorCard.vue?vue&type=template&id=12c06307&scoped=true", function () {
      api.rerender('12c06307', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messages/PasswordResetErrorCard.vue"
export default component.exports